import React from 'react';

const SkeletonCard = () => (
  <div className="result-cell">
    <div className="search-result-column">
      <div className="skel-thumbnail loading" />
      <div className="skel-content">
        <div className="skel-name loading" />
        <div className="skel-address loading" />
        <div className="skel-price loading" />
      </div>
    </div>
  </div>
);

const SpaceLoader = () => (
  <section className="loading-wrap">
    <div className="result-grid five-col">
      {Array.from({ length: 10 }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  </section>
);

export default SpaceLoader;